import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { MonetaryValue } from '../shared/models/monetary-value.model';
import { PnlPipe } from './pnl.pipe';

@Component({
  selector: 'pnl',
  standalone: true,
  imports: [
    CommonModule,
    PnlPipe
  ],
  providers: [ CurrencyPipe ],
  templateUrl: './pnl.component.html'
})
export class PnlComponent implements OnInit {
  @Input() monetaryValue!: MonetaryValue | undefined;
  @Input() suffix = false;

  pnLClass: string | undefined;

  ngOnInit() {
    if (this.monetaryValue) {
      if (this.monetaryValue.value < 0) {
        this.pnLClass = 'text-danger';
      }
    }
  }
}
